<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesNcrProcessTaskResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'"
                                      header-btn-del-disabled
                                      with-custom-row-actions-first-column>
                                <template #left-header>
                                    <b-button-group>
                                        <em-button type="process"
                                                   v-if="pathType === 'todo'"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="发起体外NCR"
                                                   :busy="ncrLoading"
                                                   @click="$refs.outLineNcr.showModal()">
                                        </em-button>
                                        <em-button type="search"
                                                   v-if="pathType === 'todo'"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :customLabel="isClaim ? '认领' : '待办'"
                                                   :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                                                   :busy="emWorkflowListLoading"
                                                   show-name
                                                   @click="switchClaim">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button type="task"
                                                   :busy="claimLoading"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :custom-label="isClaim ? '认领' : '处理'"
                                                   @click="handleExecute(row)">
                                        </em-button>
                                        <em-button v-if="pathType === 'list'"
                                                   type="fillTemplate"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="填写NCC"
                                                   @click="routeToNccPage(row)">
                                        </em-button>
                                        <em-button type="fillTemplate"
                                                   custom-icon="fa fa-bars"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="修改责任部门"
                                                   :busy="changeCausedByLoading"
                                                   @click="openChangeCausedByModal(row)">
                                        </em-button>
                                        <attach-file-btn v-if="pathType === 'list'"
                                                         :row="row"
                                                         field-key="taskAttachment"
                                                         :entity-name="modelName"
                                                         @saved="$refs.emListFilter.doQuery()">
                                        </attach-file-btn>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <ReBModal ref="outLineNcr" header="发起体外NCR" @hide="ncrDescription=''" @ok="submitNCR">
            <DiverseInput :value.sync="ncrDescription" :config="ncrDescriptionInputConfig"></DiverseInput>
        </ReBModal>

        <ReBModal ref="changeCausedBy" header="修改责任部门" @ok="changeCausedBy">
            <DiverseInput :value.sync="causedBy" :config="causedByInputConfig"></DiverseInput>
        </ReBModal>
    </div>
</template>
<script>
// Author Liang Gangqiang
// Date 2021-05-26 22:19:09
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EmCommonApi from "@/mixin/em/common/api";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import {_causedByOptions} from "@/views/sithMes/quality/NCR/stuff/causedByOption";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import AttachFileBtn from "@/components/common/inputs/AttachFileBtn.vue";

export default {
    name: "sithMesNcrProcessTaskWorkflowListView",
    components: {AttachFileBtn, DiverseInput, ReBModal},
    mixins: [emWorkflowListMixin, emCommonGotoMixin, EmCommonApi, emTableCheckedMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emRouterHelperMixin_pathType() {
            return this.isClaim ? 'claim' : this.$route.query.pathType;
        },
        pathType() {
            return this.$route.query.pathType;
        },
    },
    watch: {
        pathType() {
            this.isClaim = false;
        }
    },
    data() {
        return {
            isClaim: false,
            claimLoading: false,
            ncrLoading: false,
            ncrDescription: '',
            ncrDescriptionInputConfig: {
                label: 'NCR描述',
                type: 'input',
                require: true
            },
            selectedId: '',
            causedBy: '',
            causedByModal: false,
            causedByInputConfig: {
                label: 'Causes by',
                type: 'select',
                options: _causedByOptions(),
                require: true
            },
            changeCausedByLoading: false
        }
    },
    mounted() {
        if (this.$route.query.toClaim) {
            this.isClaim = true;
        }
        if (this.$route.query.hasOwnProperty('processId')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.processId);
            this.$refs.emListFilter.doQuery();
        }
    },
    methods: {
        switchClaim() {
            this.isClaim = !this.isClaim;
        },
        handleExecute(row) {
            console.log(row)
            if (this.isClaim) {
                if (row.workflowTask && row.workflowTask.processDefinitionKey) {
                    this.claimLoading = true;
                    this.$store.dispatch('api/post', {
                        url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/claimTask",
                        data: {
                            processDefinitionKey: row.workflowTask.processDefinitionKey,
                            businessKeyList: [row.id]
                        }
                    }).then(() => {
                        this.claimLoading = false;
                        this.$message.success("认领成功");
                        this.$_emWorkflowListMixin_init();
                    });
                }
            } else {
                this.$_emWorkflowListMixin_handleApprove(row);
            }
        },
        routeToNccPage(row) {
            this.$_emGotoMixin_gotoHolderList("sithMesNcrTaskNcc"
                , {ncrProcessIdFilter: row.id}
                , {ncrProcessId: row.id}, false, {});
        },
        submitNCR() {
            if (this.ncrDescription == null || this.ncrDescription === '') {
                this.$message.warning("请输入NCR描述");
            } else {
                this.ncrLoading = true;
                let _api = process.env.VUE_APP_SITHMES_QUALITY_URL + '/sithMesNcrProcessTask';
                this.$_emApiMixin_put(_api, {
                    ncrDescription: this.ncrDescription
                }).then(() => {
                    this.$message.success("发起成功");
                    this.switchClaim();
                }).finally(() => {
                    this.ncrLoading = false;
                });
            }
        },
        openChangeCausedByModal(row) {
            this.selectedId = row.id;
            this.causedBy = row.causedBy;
            this.$refs.changeCausedBy.showModal();
        },
        changeCausedBy() {
            this.changeCausedByLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/change/causedBy",
                data: {
                    id: this.selectedId,
                    causedBy: this.causedBy
                }
            }).then(() => {
                this.$message.success("操作成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.changeCausedByLoading = false);
        }
    }
};
</script>
